module.exports = __webpack_public_path__ + "assets/flowplayer.b5fc4c9c.svg";